import { CircleHelp, Home, LayoutDashboard, Sparkles } from 'lucide-react';

import { defineTour } from '@nucleus-commerce/admin-kit/tour';

export const welcomeTour = defineTour({
  id: 'welcome',
  version: 2,
  group: 'getting-started',
  route: '/_authed/_active/org/',
  scope: 'org',
  icon: Sparkles,
  steps: [
    { id: 'intro', kind: 'intro' },
    {
      id: 'sidebar',
      kind: 'explain',
      target: 'shell.sidebar',
      placement: 'right',
      before: { openSidebar: true },
    },
    {
      id: 'sidebar-search',
      kind: 'explain',
      target: 'shell.sidebar.search',
      placement: 'right',
      before: { openSidebar: true },
    },
    {
      id: 'store-switcher',
      kind: 'explain',
      target: 'shell.store-switcher',
      placement: 'right',
      optional: true,
      before: { openSidebar: true },
    },
    { id: 'search', kind: 'explain', target: 'shell.search', hideOnMobile: true },
    { id: 'help-menu', kind: 'explain', target: 'shell.help-menu' },
  ],
  related: ['home.store', 'catalog.products', 'orders.list'],
});

export const helpCenterTour = defineTour({
  id: 'help.center',
  version: 1,
  group: 'getting-started',
  route: '/_authed/_active/help',
  scope: 'org',
  icon: CircleHelp,
  steps: [
    { id: 'intro', kind: 'intro' },
    { id: 'progress', kind: 'explain', target: 'help.center.progress' },
    { id: 'search', kind: 'action', target: 'help.center.search', advanceOn: { input: true } },
    { id: 'groups', kind: 'explain', target: 'help.center.groups', placement: 'top' },
    { id: 'restart', kind: 'explain', target: 'help.center.restart', optional: true },
  ],
  related: ['welcome'],
});

export const homeOrgTour = defineTour({
  id: 'home.org',
  version: 1,
  group: 'getting-started',
  route: '/_authed/_active/org/',
  scope: 'org',
  icon: Home,
  steps: [
    { id: 'kpis', kind: 'explain', target: 'home.org.kpis' },
    {
      id: 'setup-checklist',
      kind: 'explain',
      target: 'home.org.setup-checklist',
      placement: 'left',
    },
    {
      id: 'recent',
      kind: 'explain',
      variants: [
        { target: 'home.org.recent-products' },
        { target: 'home.org.recent-empty', copy: 'empty' },
      ],
    },
    {
      id: 'new-product',
      kind: 'action',
      target: 'home.org.new-product',
      requires: 'products.write',
    },
  ],
  related: ['home.store', 'catalog.product-new'],
});

export const homeStoreTour = defineTour({
  id: 'home.store',
  version: 1,
  group: 'getting-started',
  route: '/_authed/_active/s/$storeId/',
  scope: 'store',
  icon: LayoutDashboard,
  steps: [
    { id: 'header', kind: 'explain', target: 'home.store.header' },
    { id: 'kpis', kind: 'explain', target: 'home.store.kpis', requires: 'reports.read' },
    {
      id: 'launch-checklist',
      kind: 'explain',
      target: 'home.store.launch-checklist',
      requires: 'stores.read',
    },
    {
      id: 'launch-show-me',
      kind: 'explain',
      target: 'home.store.launch-show-me',
      requires: 'stores.read',
      optional: true,
    },
    { id: 'quick-links', kind: 'explain', target: 'home.store.quick-links', optional: true },
  ],
  related: ['settings.hub', 'store-catalog.list'],
});
